export const UrlFilterHelper = {
    GetFilterdUrl
}

function GetFilterdUrl(url, skipCount, search, orderBy, dsc, size) {
    url += "?skipCount=" + skipCount

    if (search != null) {
        url += "&search=" + search;
    }

    if (orderBy != null) {
        url += "&sorting=" + orderBy;

        if (dsc) {
            url += " desc";
        }
    }

    if (size != null) {
        url += "&maxResultCount=" + size;
    }

    return url;
}